export function checkForExternalAuthRequiredResult(data:any) {
  return data && data.success == false && Array.isArray(data.errors) && data.errors.length && data.errors[0].code == "OAUTH_REQUIRED";
}
